module.exports = __webpack_public_path__ + "6e6593591cf0803b5398064c8f492a85.png";